<template lang="pug">
.traceability-contract-view-page
        base-header(:titulo="$t('relatorio_rastreabilidade.messages.traceabilityReport.title')" :voltarPara='true')
        .view-container-wrapper
            .content
                total-volume(ref="totalVolume")
                report-data(ref="reportData")
                added-volume(ref="addedVolume")
                report-list(ref="reportList")
</template>
<script>

export default {
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        TotalVolume: () => import('@/modules/traceability-report/views/components/total-volume/index.vue'),
        ReportData: () => import('@/modules/traceability-report/views/pages/view/components/report-data/index.vue'),
        AddedVolume: () => import('@/modules/traceability-report/views/components/added-volume/index.vue'),
        ReportList: () => import('@/modules/traceability-report/views/pages/view/components/report-list/index.vue')
    }
};
</script>
<style scoped lang="scss">
.traceability-contract-view-page {
    .view-container-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
    }
}
</style>
